var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVismaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171.6 35.1",
    style: {
      enableBackground: "new 0 0 171.6 35.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LABEL"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M19.4,2c9.1,0.8,19.2,5.4,24.9,12c7.3,8.4,4.8,16.8-5.6,18.7c-10.4,2-24.8-3.3-32.2-11.6 C0.9,14.6,1,8.2,6.1,4.7l29,21.4L19.4,2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M162.8,32.7L159.2,18c-0.5-1.7-0.7-3.5-1.1-5.2H158c-0.3,1.8-0.4,3.5-0.9,5.3l-3.7,14.6H147 l8.5-30.5h4.9l8.8,30.5H162.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M66.4,2.1L70,16.8c0.5,1.7,0.7,3.5,1.1,5.2h0.1c0.3-1.8,0.4-3.5,0.9-5.3l3.7-14.6h6.3l-8.5,30.5 h-4.9L60,2.1H66.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M92.8,2.1v30.5h-6V2.1H92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M126.9,2.1l3,18h0.1l2.4-18h8.1l3.2,30.5h-6.2l-1.5-22h-0.1l-1,7.5l-2.6,14.5h-4.7l-3-14.6 l-1-6.8v-0.6h-0.1l-0.9,22h-6.5l2.7-30.5C118.8,2.1,126.9,2.1,126.9,2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M107.7,2.1c-1,0.7-1.8,2-2.4,3.3c-1.6,3.8,0.1,6.7,1.6,9.3c0.2,0.4,0.4,0.8,0.7,1.1 c3.3,5.6,4.5,9.7,2.1,15.6c-0.2,0.4-0.6,1.2-0.6,1.2h-7.3c0.8-0.7,1.7-1.7,2.2-2.9c1.7-4-0.3-7.7-2.2-11.3 c-2.3-4.3-4.7-8.7-2.1-14.8C99.9,3,100.5,2,100.5,2L107.7,2.1L107.7,2.1z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVismaLogo);
export default __webpack_public_path__ + "static/media/visma-logo.124219eb4a694d2958edc44983a56507.svg";
export { ForwardRef as ReactComponent };